module.exports = __webpack_public_path__ + "640657aa8764e3ee09a9d216d381457b.png";